import React from 'react';
import { Form, Card, Button } from 'react-bootstrap';
import { updateDoc, doc, collection, getDocs } from 'firebase/firestore';
import { db } from '../firebase';

const EditPost = ({ editingPost, setEditingPost, setPosts }) => {

  const handleUpdatePost = async (e) => {
    e.preventDefault();

    try {
      const postRef = doc(db, 'posts', editingPost.id);
      await updateDoc(postRef, {
        title: editingPost.title,
        content: editingPost.content
      });

      console.log('Post updated!');

      const postsCol = collection(db, 'posts');
      const postSnapshot = await getDocs(postsCol);
      const postsList = postSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      setPosts(postsList);

      setEditingPost(null);
    } catch (error) {
      console.error('Error updating post:', error);
    }
  };

  return (
    <Card className="p-4">
      <h2>Edit Blog Post</h2>
      <Form onSubmit={handleUpdatePost}>
      <Form.Group controlId="editPostTitle">
    <Form.Label>Title</Form.Label>
    <Form.Control 
        type="text" 
        placeholder="Enter post title" 
        value={editingPost.title} 
        onChange={(e) => setEditingPost({ ...editingPost, title: e.target.value })} 
        required 
    />
</Form.Group>

<Form.Group controlId="editPostContent">
    <Form.Label>Content</Form.Label>
    <Form.Control 
        as="textarea" 
        rows={5}
        placeholder="Enter post content" 
        value={editingPost.content} 
        onChange={(e) => setEditingPost({ ...editingPost, content: e.target.value })} 
        required 
    />
</Form.Group>

<Button id='x2' variant="primary" type="submit">Update</Button>
<Button id='x2' variant="secondary" onClick={() => setEditingPost(null)}>Cancel</Button>
      </Form>
    </Card>
  );
};

export default EditPost;
